import simpleReducer from 'app/common/utils/simple-reducer';
// biome-ignore lint/suspicious/noShadowRestrictedNames: Immutable.js Map/Set
import { fromJS, Map } from 'immutable';
import _mapValues from 'lodash/mapValues';
import { createPublishTarget } from '../../actions.js';

// If error has response, set field errors in the form
export default simpleReducer(Map(), {
  [createPublishTarget.REJECTED](state, { payload }) {
    if (payload.response) {
      const errors = _mapValues(payload.response.data.errors, (v) => v.join(', '));
      const nameError = errors.subdomain;
      return state.set('errors', fromJS({ ...errors, name: nameError }));
    }

    return state;
  }
});
